import { Action, OidcContext } from '../types';
import { buildMicrobranding } from '../utilities/init-app-state';

export const updateMicrobranding = (oidcContext: OidcContext): Action => ({
  type: 'MICROBRANDING_UPDATE',
  microbranding: buildMicrobranding(oidcContext),
});
